
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/download-app",
      function () {
        return require("private-next-pages/fr/download-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/download-app"])
      });
    }
  